import { TransactionDetailRow } from "@/components";
import { memo } from "react";
import { twMerge } from "tailwind-merge";

export const TransactionArrow = memo(function TransactionArrow({
    className,
}: {
    className?: string;
}) {
    return (
        <TransactionDetailRow
            label=""
            value="↓"
            className={twMerge("pr-[24px] opacity-60 h-[10px] flex justify-end", className)}
        />
    );
});

TransactionArrow.displayName = "TransactionArrow";
